























































import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/prescription';
import * as prescriptionTypes from '@/settings/consts/prescriptions-types';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { IdNomeDTO } from '../../../interfaces/base-dto';
import SimplifiedPrescriptionDialog from './simplified-dialog.vue';

@Component({ components: { SimplifiedPrescriptionDialog } })
export default class PrescriptionTypesBlank extends BaseComponent {
  @Prop()
  public item;
  @Prop()
  public currentTab: string;
  @Prop()
  public tabName: string;
  @Prop()
  public tabIndex?: string;
  @Prop()
  public imc;

  TP_BLANK_FORM = 'C';
  TP_THERAPY_FORM = 'T';
  TP_SIMPLIFIED_FORM = 'S';
  tpForm = this.TP_BLANK_FORM;

  openSimplifiedForm = false;

  public loading: boolean = false;
  private terapias: IdNomeDTO[] = [];
  private terapia: IdNomeDTO = null;
  private terapiaAnt: IdNomeDTO = null;
  hasTherapy = false;
  hasSimpleTherapy = false;

  txtInfoFarmoExpress = "Fórmula sugerida com base nos guidelines mais recentes, "
  + "de acordo com a situação clínica informada pelo médico prescritor, <br>" 
  + "que deverá conferir a adequação e modificar se necessário, "
  + "a fim de individualizar a nutrição parenteral para cada paciente."

  isShowTherapies() {
    return (
      (this.item.isVisualization() && this.item.terapia && this.item.terapia.id) ||
      (this.terapias &&
        this.terapias.length &&
        this.item.unidade &&
        this.item.unidade.id &&
        this.item.medico &&
        this.item.medico.id &&
        this.item.paciente &&
        this.item.paciente.id &&
        this.tpForm == this.TP_THERAPY_FORM)
    );
  }

  @Watch('item')
  public onChangeItem(val: any): void {
    this.terapia = null;
  }

  @Watch('item.terapia')
  public onChangeItemTerapia(val: any): void {
    this.terapia = val;
  }

  @Watch('item.unidade')
  public onChangeUnit(val: any): void {
    this.resetTherapySelected();
    this.loadTherapies();
  }

  private resetTherapySelected(resetTpForm = true) {
    this.terapia = null;
    this.$emit('updateTherapy', null);
    if (resetTpForm) {
      this.tpForm = this.TP_BLANK_FORM;
    }
  }

  @Watch('item.medico')
  public onChangeDoctor(val: any): void {
    this.resetTherapySelected();
  }

  @Watch('item.paciente')
  public onChangePaciente(val: any): void {
    this.resetTherapySelected();
    this.checkSimpleTherapyAvailable();
  }

  @Watch('item.paciente.peso')
  public onChangePesoPaciente(val: any): void {
    this.resetTherapySelected();
  }

  @Watch('item.tipoPrescricao')
  public onChangeTipoPrescricao(): void {
    this.resetTherapySelected();
  }

  @Watch('tpForm')
  public onChangeTipoFormulario(tp: any): void {
    this.resetTherapySelected(false);
    this.openSimplifiedForm = tp == this.TP_SIMPLIFIED_FORM;
  }

  public onCancelSimplifiedForm() {
    this.openSimplifiedForm = false;
    this.tpForm = this.TP_BLANK_FORM;
    this.resetTherapySelected();
  }

  mounted() {
    this.loadTherapies();
    this.checkSimpleTherapyAvailable();
  }

  public loadTherapies(): void {
    this.terapias = [];

    if (this.item.isVisualization() || !this.item.unidade || !this.item.unidade.id) {
      return;
    }

    this.loading = true;
    service.getTherapiesPrescription(this.item.unidade.id, prescriptionTypes.DEFAULT).subscribe(
      (data) => {
        this.terapias = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }

  checkSimpleTherapyAvailable() {
    if (!this.item || !this.item.paciente || !this.item.paciente.id) {
      this.hasSimpleTherapy = false;
      return;
    }
    service.isSimpleTherapyPrescriptionAvailable(this.item.paciente.id, this.item.unidade.id).subscribe((res) => {
      this.hasSimpleTherapy = res;
    });
  }

  timeoutChange = null;
  private onTerapiaChange(terapia: any, diasTn: string): void {
    if (this.item.isVisualization()) {
      return;
    }
    if (this.terapiaAnt) {
      this.loader.start('Preparando...');
      this.resetTherapySelected(false);
      this.terapia = terapia;
      if (this.timeoutChange) {
        clearTimeout(this.timeoutChange);
      }
      this.timeoutChange = setTimeout(() => {
        this.loader.stop();
        this.$emit('updateTherapy', terapia, diasTn);
      }, 2000);
    } else {
      this.$emit('updateTherapy', terapia, diasTn);
    }
    this.terapiaAnt = terapia;
  }

  @Watch('terapias')
  onTherapiesChange() {
    this.hasTherapy = this.terapias && this.terapias.length > 0;
  }

  onChangePatientHeight(v) {
    this.$emit('changePatientHeight', v);
  }
}
